export default function CardInputIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="2"
        width="14"
        height="12"
        rx="2"
        fill="var(--quaternery-color)"
      />
      <rect
        x="1"
        y="4"
        width="14"
        height="3"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
